var generic = generic || {};
var site = site || {};

site.ReferAFriendV1 = site.ReferAFriendV1 || {};

(function ($) {
  'use strict';

  function returnToTopForm(position) {
    var is_mobile = $('body').hasClass('device-mobile');

    if (is_mobile) {
      $('html, body').animate({ scrollTop: $(position).offset().top - 40 });
    }
  }
  function modifyFriendsNumber(maximum) {
    if (site.ReferAFriendV1.$friends_added_hidden.text().length && (site.ReferAFriendV1.$friends_added_hidden.text().indexOf('#friends#') >= 0)) {
      var text_aux = site.ReferAFriendV1.$friends_added_hidden.text().replace('#friends#', maximum);

      site.ReferAFriendV1.$friends_added_text.text(text_aux);
    }
  }
  // AddFriendText
  function addFriendName(name, surname) {
    // site.ReferAFriendV1.$friend_names.append(name + " " + surname +'<br>');
    // site.ReferAFriendV1.$friend_names2.append(name + " " + surname +'<br>');
    site.ReferAFriendV1.$friend_names.append("<div id='friend_number_" + site.ReferAFriendV1.i + "' style='display: none;'>" + name + ' ' + surname + '</div>');
    $('#friend_number_' + site.ReferAFriendV1.i).slideDown('slow');
    site.ReferAFriendV1.i = site.ReferAFriendV1.i + 1;
    site.ReferAFriendV1.$friend_names2.append(name + ' ' + surname + '<br>');
  }
  // SendGift
  function sendGift(context, next_action) {
    site.ReferAFriendV1.$submit_block.find('#rafsendgifts_submit').prop('disabled', true);
    site.ReferAFriendV1.$submit_block.find('#rafsendmoregifts_submit').prop('disabled', true);

    if (!validateFields(context)) {
      site.ReferAFriendV1.$submit_block.find('#rafsendgifts_submit').prop('disabled', false);
      site.ReferAFriendV1.$submit_block.find('#rafsendmoregifts_submit').prop('disabled', false);

      return;
    }
    AddFriend(context, next_action);
  }
  // Validate functions
  function validateFields(context) {
    var error = true;
    var error_messages = site.ReferAFriendV1.$error_messages;

    if (!error_messages.find('#error_email').hasClass('hidden')) {
      error_messages.find('#error_email').addClass('hidden');
    }
    if (!error_messages.find('#error_text').hasClass('hidden')) {
      error_messages.find('#error_text').addClass('hidden');
    }
    if (!error_messages.find('#error_recaptcha').hasClass('hidden')) {
      error_messages.find('#error_recaptcha').addClass('hidden');
    }
    if (!error_messages.find('#error_duplicated_friend').hasClass('hidden')) {
      error_messages.find('#error_duplicated_friend').addClass('hidden');
    }
    if (!error_messages.find('#error_generic').hasClass('hidden')) {
      error_messages.find('#error_generic').addClass('hidden');
    }

    $('form#referafriend :input[type=text]').each(function () {
      var input = $(this);

      input.removeClass('error');
      if (!validateTextField(input.val())) {
        input.addClass('error');
        error = false;
        error_messages.find('#error_text').removeClass('hidden');

        return error;
      }
    });
    if (!error) {
      return false;
    }
    $('form#referafriend :input[type=email]').each(function () {
      var input = $(this);

      input.removeClass('error');
      if (!validateTextField(input.val()) || !validateEmailField(input.val())) {
        input.addClass('error');
        error = false;
        error_messages.find('#error_email').removeClass('hidden');

        return error;
      }
    });
    if (!error) {
      return false;
    }

    if (duplicatedFriend()) {
      error_messages.find('#error_duplicated_friend').removeClass('hidden');
      error = false;

      return error;
    }
    if (!error) {
      return false;
    }

    var recaptcharesponse = $('#g-recaptcha-response');

    if (!validateTextField(recaptcharesponse.val())) {
      error = false;
      error_messages.find('#error_recaptcha').removeClass('hidden');
    }

    return error;
  }

  function validateEmailField($email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,15})?$/;

    return emailReg.test($email);
  }
  function validateTextField($text) {
    $text = $.trim($text);
    if (!$text) {
      return false;
    }

    return true;
  }
  function duplicatedFriend() {
    var duplicated = false;

    site.ReferAFriendV1.$friends.forEach(function (friend, index) {
      // var original = $.trim(site.ReferAFriendV1.$friends[index].CUSTOM_GREA).toUpperCase(); 
      var original = $.trim(friend.CUSTOM_GREA).toUpperCase();
      var actual = $.trim(site.ReferAFriendV1.$CUSTOM_GREA.val()).toUpperCase();

      if (original == actual) {
        duplicated = true;

        return true;
      }
    });

    return duplicated;
  }
  // Add Friend
  function AddFriend(context, next_action) {
    if (typeof next_action === 'undefined' || !next_action.length) {
      next_action = 'add';
    }
    var params = {
      '_SUBMIT': 'refer_a_friend',
      // 'PROMOTION_ID': site.ReferAFriendV1.PROMOTION_ID,
      // 'PROMOTION_CODE': site.ReferAFriendV1.PROMOTION_CODE,
      // 'LAST_SOURCE': site.ReferAFriendV1.LAST_SOURCE,
      // 'ORIGINAL_SOURCE': site.ReferAFriendV1.ORIGINAL_SOURCE,
      'CUSTOM_GRFN': site.ReferAFriendV1.$CUSTOM_GRFN.val(),
      'CUSTOM_GRLN': site.ReferAFriendV1.$CUSTOM_GRLN.val(),
      'CUSTOM_GREA': site.ReferAFriendV1.$CUSTOM_GREA.val(),
      'CUSTOM_UN': site.ReferAFriendV1.$CUSTOM_UN.val(),
      'PC_EMAIL_ADDRESS': site.ReferAFriendV1.$PC_EMAIL_ADDRESS.val(),
      'PROMOTION_ID': site.ReferAFriendV1.$PROMOTION_ID.val(),
      'PROMOTION_CODE': site.ReferAFriendV1.$PROMOTION_CODE.val(),
      'LAST_SOURCE': site.ReferAFriendV1.$LAST_SOURCE.val(),
      'ORIGINAL_SOURCE': site.ReferAFriendV1.$ORIGINAL_SOURCE.val(),

      '_NEXT_ACTION': 'add'
    };
    var recaptcharesponse = $('#g-recaptcha-response');

    if (recaptcharesponse) {
      // params['CAPTCHA'] = "1";
      params['g-recaptcha-response'] = recaptcharesponse.val();
    }

    generic.jsonrpc.fetch({
      method: 'rpc.form', // logic.checkout--viewcart
      params: [params],
      onSuccess: function (response) {
        // Add element to the array
        site.ReferAFriendV1.$friends.push({
          'CUSTOM_GRFN': params.CUSTOM_GRFN,
          'CUSTOM_GRLN': params.CUSTOM_GRLN,
          'CUSTOM_GREA': params.CUSTOM_GREA,
          'CUSTOM_UN': params.CUSTOM_UN,
          'PC_EMAIL_ADDRESS': params.PC_EMAIL_ADDRESS
        });
        // add friend name to the list
        addFriendName(params.CUSTOM_GRFN, params.CUSTOM_GRLN);

        // Change the Block Visible
        if (site.ReferAFriendV1.$BLOCK_NAMES.hasClass('hidden')) {
          site.ReferAFriendV1.$BLOCK_GIFT.addClass('hidden');
          // site.ReferAFriendV1.$BLOCK_NAMES.removeClass("hidden");
          site.ReferAFriendV1.$BLOCK_NAMES.css('display', 'none');
          site.ReferAFriendV1.$BLOCK_NAMES.removeClass('hidden');
          site.ReferAFriendV1.$BLOCK_NAMES.slideDown('fast');
        }
        site.ReferAFriendV1.$submit_block.find('#rafsendgifts_submit').prop('disabled', false);
        site.ReferAFriendV1.$submit_block.find('#rafsendmoregifts_submit').prop('disabled', false);

        // Clean the Friend Data
        site.ReferAFriendV1.$CUSTOM_GRFN.val('');
        site.ReferAFriendV1.$CUSTOM_GRLN.val('');
        site.ReferAFriendV1.$CUSTOM_GREA.val('');

        // Check if the maximum number of friends is reached
        site.ReferAFriendV1.maximum = site.ReferAFriendV1.maximum - 1;
        if ((site.ReferAFriendV1.maximum <= 0) || next_action == 'end') {
          // We finish the promotion
          site.ReferAFriendV1.$BLOCK_GIFT.addClass('hidden');
          site.ReferAFriendV1.$BLOCK_NAMES.addClass('hidden');
          site.ReferAFriendV1.$BLOCK_FORM.addClass('hidden');
          site.ReferAFriendV1.$BLOCK_THANKS.removeClass('hidden');
        } else {
          modifyFriendsNumber(site.ReferAFriendV1.maximum);
        }
        grecaptcha.reset();
        returnToTopForm('#content_refer_a_friend');
      },
      onFailure: function (response) {
        // display error
        var errorObjectsArray = response.getMessages();
        var errorHTML = '';

        for (var i = 0; i < errorObjectsArray.length; i++) {
          if (errorObjectsArray[i].text == 'invalid.captcha.refer_a_friend') {
            errorHTML = site.ReferAFriendV1.$error_messages.find('#error_recaptcha').text();
            break;
          }
          // if(errorObjectsArray[i].severity=="MESSAGE") {
          if (errorObjectsArray[i].severity == 'ERROR') {
            errorHTML += errorObjectsArray[i].text + '<br>';
          }
        }

        if (errorHTML.length) {
          site.ReferAFriendV1.$error_messages_generic.html(errorHTML);
        } else {
          if (site.ReferAFriendV1.$error_messages.find('#error_generic').hasClass('hidden')) {
            site.ReferAFriendV1.$error_messages.find('#error_generic').removeClass('hidden');
          }
        }
        grecaptcha.reset();
        // returnToTopForm("#block-form");
        site.ReferAFriendV1.$submit_block.find('#rafsendgifts_submit').prop('disabled', false);
        site.ReferAFriendV1.$submit_block.find('#rafsendmoregifts_submit').prop('disabled', false);
      }
    });
  }
  // Refer a Friend functionality
  Drupal.behaviors.ReferAFriendV1 = {
    init: function (context) {
      site.ReferAFriendV1 = {
        i: 1,
        maximum: 5,
        $CUSTOM_GRFN: $('#CUSTOM_GRFN', context),
        $CUSTOM_GRLN: $('#CUSTOM_GRLN', context),
        $CUSTOM_GREA: $('#CUSTOM_GREA', context),
        $CUSTOM_UN: $('#CUSTOM_UN', context),
        $PC_EMAIL_ADDRESS: $('#PC_EMAIL_ADDRESS', context),
        $PROMOTION_ID: $('#PROMOTION_ID', context),
        $PROMOTION_CODE: $('#PROMOTION_CODE', context),
        $LAST_SOURCE: $('#LAST_SOURCE', context),
        $ORIGINAL_SOURCE: $('#ORIGINAL_SOURCE', context),
        $recaptcha_response: $('#g-recaptcha-response', context),
        $error_messages: $('.raf__messages .raf__message--error', context),
        $error_messages_generic: $('.raf__messages .raf__message__generic--error', context),

        $submit_block: $('.content-block-large__cta-wrap', context),

        $friend_names: $('.block-names .friend-names', context),
        $friend_names2: $('.block-thanks .friend-names', context),
        $friends_added_text: $('.block-names #friends_added_text', context),
        $friends_added_hidden: $('.block-names #friends_added_hidden', context),

        $BLOCK_GIFT: $('.block-gift', context),
        $BLOCK_NAMES: $('.block-names', context),
        $BLOCK_THANKS: $('.block-thanks', context),
        $BLOCK_FORM: $('.block-form', context),

        $friends: []
      };

      // Show the submit buttons
      site.ReferAFriendV1.$submit_block.removeClass('hidden');

      $(document).on('click', '#rafsendgifts_submit', function (event) {
        event.preventDefault();
        sendGift(context, 'end');
      });

      $(document).on('click', '#rafsendmoregifts_submit', function (event) {
        event.preventDefault();
        sendGift(context, 'add');
      });
    },
    attach: function (context) {
      this.init(context);
    }
  };
})(jQuery);
